import {ModalContext} from '#/contexts/modal-provider';
import {WalletContext} from '#/contexts/wallet-provider';
import {useContext, useEffect} from 'react';

export const useAfterLoginModal = () => {
  const {
    accountResult: {isConnected},
    web3Auth,
  } = useContext(WalletContext);
  const {open} = useContext(ModalContext);

  const isAfterLoginShown = localStorage.getItem('isAfterLoginShown') === 'true';

  useEffect(() => {
    if (!isConnected || !web3Auth?.connected || isAfterLoginShown) {
      return;
    }

    open({
      name: 'AfterLoginModal',
      props: {},
    });

    localStorage.setItem('isAfterLoginShown', 'true');
  }, [isConnected, web3Auth?.connected, isAfterLoginShown]); // eslint-disable-line react-hooks/exhaustive-deps
};
